import { P, Radio, RadioField } from '@ovotech/nebula';
import { useAtom } from 'jotai';
import { focusAtom } from 'jotai/optics';
import React from 'react';
import BackButton from '../components/back-button/BackButton';
import FormSection from '../components/form-section/FormSection';
import HowFindThisLink, { ImageType } from '../components/how-find-this-link/HowFindThisLink';
import NextButton from '../components/next-button/NextButton';
import RadioSet from '../components/radio-set/RadioSet';
import StepCounter from '../components/step-counter/StepCounter';
import { meterTypeAtom, stateAtom, WanState } from '../state';
import { NavigationProps } from './types';

const atom = focusAtom(stateAtom, (optic) => optic.prop('wanState'));

const WanLight: React.FC<NavigationProps> = ({ onBack, onNext }) => {
  const [meterType] = useAtom(meterTypeAtom);
  const [state = 'Flashing', setState] = useAtom(atom);

  return (
    <FormSection>
      <BackButton onClick={onBack} />
      <StepCounter />
      <P>Next, look for a light labelled WAN on the front of your electricity meter.</P>
      <HowFindThisLink meterType={meterType} imageType={ImageType.WAN} />
      <RadioSet>
        <RadioField
          name="wanState"
          label="The WAN light is:"
          defaultValue={state}
          onValueChange={(value) => setState(value as WanState)}
        >
          <Radio label="Flashing" id="wanStateFlashing" value="Flashing" />
          <Radio label="Off" id="wanStateOff" value="Off" />
          <Radio label="On" id="wanStateOn" value="On" />
        </RadioField>
      </RadioSet>
      <NextButton onClick={onNext} trackOptions={['WAN state entered']} />
    </FormSection>
  );
};

export default WanLight;
